<template>
  <svg width="17" height="12" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.91667 0.75H15.75M4.91667 5.75H15.75M4.91667 10.75H15.75M0.75 0.75H0.758333M0.75 5.75H0.758333M0.75 10.75H0.758333"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
